import React from 'react';
import { Button, CircularProgress, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import './PlaylistManagement.scss';

const songLabel = (song) => song.name || song.title || song.fileName || song.id || 'Unnamed song';

export default function PlaylistConflictDialog({ conflict, open, onClose, onReload, onRetry, onAddAndReload, reloadOnly = false, busy = false, recoveryError }) {
  if (!conflict) return null;

  const latestSongs = conflict.latest?.songs || [];
  const draftSongs = conflict.draft || [];

  return <Dialog open={open} onClose={busy ? undefined : onClose} fullWidth maxWidth="md">
    <DialogTitle>Playlist changed elsewhere</DialogTitle>
    <DialogContent>
      <p>Your changes were not saved because the saved song list changed while you were editing.</p>
      {reloadOnly ? <p>Your additions were saved. Retry loading the latest playlist without adding those songs again.</p>
        : onAddAndReload ? <p>Use Add &amp; reload to add only your new songs to the latest playlist. Existing songs and their order will be kept, and duplicates will be skipped.</p>
        : <p>These edits cannot be merged automatically. Review both lists, then reload the latest playlist and redo the changes you still want. Reloading discards your unsaved edits, including name, type, and tags.</p>}
      {recoveryError && <p role="alert">{recoveryError}</p>}
      {conflict.loading ? <CircularProgress size={24} /> : conflict.latest ?
        <div className="playlist-conflict-columns">
          <section>
            <h3>Latest saved list ({latestSongs.length})</h3>
            <ol>{latestSongs.map((song, index) => <li key={`${song.id}-${index}`}>{songLabel(song)}</li>)}</ol>
          </section>
          <section>
            <h3>Your unsaved list ({draftSongs.length})</h3>
            <ol>{draftSongs.map((song, index) => <li key={`${song.id}-${index}`}>{songLabel(song)}</li>)}</ol>
          </section>
        </div> :
        <p role="alert">Could not load the latest playlist. Your unsaved list is still here.</p>}
      <div className="playlist-management-footer">
        <Button disabled={busy} onClick={onClose}>Keep editing</Button>
        {!conflict.loading && !conflict.latest && <Button disabled={busy} onClick={onRetry}>Retry loading</Button>}
        <Button color="primary" variant={onAddAndReload ? "text" : "contained"} disabled={busy || !conflict.latest || conflict.loading} onClick={() => onReload()}>
          Reload & redo edits
        </Button>
        {onAddAndReload && <Button color="primary" variant="contained" disabled={busy || conflict.loading} onClick={onAddAndReload}>
          {busy ? (reloadOnly ? 'Reloading…' : 'Adding & reloading…') : (reloadOnly ? 'Retry reload' : 'Add & reload')}
        </Button>}
      </div>
    </DialogContent>
  </Dialog>;
}
